// extracted by mini-css-extract-plugin
module.exports = {"action":"LegendeCreneauAbsence_action__2RbgI"};